import { DateTime } from 'luxon';

export function formatSimpleTime(utcISO: string) {
  return DateTime.fromISO(utcISO).toLocaleString(DateTime.TIME_SIMPLE);
}
